import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class OnlineDonationStateService {

  constructor(private _HttpClient:HttpClient) { }

  GetDonationHome(data:any):Observable<any>{
      return this._HttpClient.post(`${environment.Server_URL}/Dashboard/DonationHome`,data);
  }

}
